import { render, staticRenderFns } from "./sla.vue?vue&type=template&id=21a8cc20&scoped=true"
import script from "./sla.vue?vue&type=script&lang=js"
export * from "./sla.vue?vue&type=script&lang=js"
import style0 from "./sla.vue?vue&type=style&index=0&id=21a8cc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8cc20",
  null
  
)

export default component.exports